// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_46-0";